import * as React from 'react';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import logo from '../images/logosmall.png';
import authService from './api-authorization/AuthorizeService';
import { ApplicationPaths } from './api-authorization/ApiAuthorizationConstants';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

interface NavMenuItems {
    isAuthenticated: boolean;
    collapsed: boolean;
    permissions: string[];
    isDriverSystem: boolean;
    companyId: number;
    noRunsheetDriverJobs: number;
    noItemTasks: number;
    noCredits: number;
    errorMessage: string;
    loading: boolean;
    redirect: boolean;
    redirectPath: string;
    system: string;
    username: string;
    menu: boolean;
}

export class NavMenu extends React.Component<{}, NavMenuItems> {
    static displayName = NavMenu.name;

    constructor(props: any) {
        super(props);

        this.state = {
            isAuthenticated: false,
            collapsed: false,
            permissions: [],
            isDriverSystem: false,
            companyId: 0,
            noRunsheetDriverJobs: 0,
            noItemTasks: 0,
            noCredits: 0,
            errorMessage: "",
            loading: false,
            redirect: false,
            redirectPath: "",
            system: "",
            username: "",
            menu: false
        };
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const isAuthenticated = await authService.isAuthenticated();
        this.setState({ isAuthenticated: isAuthenticated });

        if (isAuthenticated) {
            const token = await authService.getAccessToken();

            if (token) {
                axios.get('api/Menu/GetShortSystem', {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                })
                .then(res => {
                    this.setState({ system: res.data });
                });

                const user = await authService.getUser();
                var name = cookies.get('da');
                this.setState({ username: name });
                if (user) {
                    axios.get('api/User/GetUserPermissions?SubId=' + user.sub, {
                        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                    })
                    .then(res => {
                        this.setState({ permissions: res.data.permissions, companyId: res.data.companyId, isDriverSystem: res.data.isDriverSystem, errorMessage: res.data.errorMessage, loading: false })
                        this.getNumberOfRunsheetDriverJobs(token, user.sub);
                        
                        if (res.data.permissions.indexOf("ViewItemTasks") > 0) {
                            //if user has permission to Item Tasks then get the number of outstanding tasks
                            this.getNumberOfItemTasks(token, user.sub);
                        }

                        if (res.data.permissions.indexOf("ViewSendInvoiceCredits") > 0) {
                            //if user has permission to Item Tasks then get the number of outstanding tasks
                            this.getNumberOfCreditTasks(token, user.sub);
                        }
                    })
                    .catch(error => {
                        var loc = window.location.pathname;
                        this.setState({ redirect: true, redirectPath: loc });
                    });
                }
            }
        }
    }

    async getNumberOfRunsheetDriverJobs(token: string, subId: string) {

        axios.get('api/RunSheet/GetRunsheetDriverJobsNumber?SubId=' + subId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ noRunsheetDriverJobs: res.data });
        });
    }

    async getNumberOfItemTasks(token: string, subId: string) {
        axios.get('api/ItemTask/GetItemTasksNumber?SubId=' + subId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ noItemTasks: res.data });
        });
    }

    async getNumberOfCreditTasks(token: string, subId: string) {
        axios.get('api/Invoicing/GetInvoiceCreditNumber?SubId=' + subId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ noCredits: res.data });
        });
    }

    toggleNavbar = () => {
        let showMenu = this.state.menu;
        if (window.innerWidth <= 760) {
            showMenu = !showMenu;
        }

        this.setState({
            collapsed: !this.state.collapsed, menu: showMenu
        });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        var permissions = this.state.permissions;
        var companyId = this.state.companyId;
        let logoutPath = { pathname: `${ApplicationPaths.LogOut}`, state: { local: true } };
        let loginPath = `${ApplicationPaths.Login}`;
        let show = (this.state.menu) ? "show" : "";
        //Show Nav Menu when authenticated or if not authenticated then just on mobile as it has the login button.

        return (
            <div className={this.state.isAuthenticated ? "" : "showMobile" }>
                <div className="top-nav--mobile">
                    <nav className="navbar navbar-expand-md navbar-light bg-light">
                        <div className="navbar-brand"><img className="logo logo__small" src={logo}></img></div>
                        <span>{this.state.username}</span>
                        <button className={this.state.isAuthenticated ? "navbar-toggler marginRight10" : "hidden"} type="button" onClick={this.toggleNavbar} aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className={this.state.isAuthenticated ? "hidden" : ""}>
                            <NavLink className="logout-button" to={loginPath}>Login</NavLink>
                        </div>
                    </nav>
                </div>
                <nav className={"navbar navbar-expand-md navbar-light " + (show ? "navbar-mobile-margin" : "")}>
                    <div className={"collapse navbar-collapse " + show} id="navbarSupportedContent">
                        <ul className="navbar-nav mt-2 mt-lg-0" onClick={this.toggleNavbar}>
                            <li className="nav-item">
                                <NavLink className="nav-link alignitemscentre" to={'/'} exact activeClassName='active'>
                                    <span className='fas fa-home menu--icon marginRight10'></span> Home
                                </NavLink>
                            </li>
                            <li className={companyId === 2 ? "hidden" : "hidden"}>
                                <NavLink className="nav-link alignitemscentre" to={'/tasks'} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Tasks
                                </NavLink>
                            </li>
                            <li className="nav-item hideMobile">
                                <NavLink className="nav-link alignitemscentre" to={'/jobsearch'} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Job Search
                                </NavLink>
                            </li>
                            <li className={permissions.indexOf("CreateJob") < 0 ? "hidden" : "nav-item hideMobile"}>
                                <NavLink className="nav-link alignitemscentre" to={'/newjob/' + (this.state.companyId === 3 ? 2 : 1)} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> New Job
                                </NavLink>
                            </li>
                            <li className={permissions.indexOf("CreateJob") < 0 || companyId != 3 ? "hidden" : "nav-item hideMobile"}>
                                <NavLink className="nav-link alignitemscentre" to={'/newjob/3'} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> New Quote
                                </NavLink>
                            </li>
                            <li className={permissions.indexOf("ViewItemTasks") < 0 ? "hidden" : "nav-item hideMobile"}>
                                <NavLink className="nav-link alignitemscentre" to={'/itemtasks'} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Item Tasks({this.state.noItemTasks})
                                </NavLink>
                            </li>
                            <li className={permissions.indexOf("CreateEditSchedule") < 0 || companyId != 2 ? "hidden" : "nav-item hideMobile"}>
                                <NavLink className="nav-link alignitemscentre" to={'/schedulenew'} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Schedule
                                </NavLink>
                            </li>
                            <li className={permissions.indexOf("ViewTiltCraneSchedule") < 0 ? "hidden" : "nav-item hideMobile"}>
                                <NavLink className="nav-link alignitemscentre" to={'/scheduletiltcrane'} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Tilt/Crane Schedule
                                </NavLink>
                            </li>
                            <li className={permissions.indexOf("ViewEventSchedule") < 0 || companyId != 3 ? "hidden" : "nav-item hideMobile"}>
                                <NavLink className="nav-link alignitemscentre" to={'/scheduleevent'} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Event Schedule
                                </NavLink>
                            </li>
                            <li className={companyId != 2 ? "nav-item hideMobile" : "hidden"}>
                                <NavLink className="nav-link alignitemscentre" to={'/schedulepickup'} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Schedule Pickup
                                </NavLink>
                            </li>
                            <li className={permissions.indexOf("ViewAllocation") < 0 ? "hidden" : "nav-item hideMobile"}>
                                <NavLink className="nav-link alignitemscentre" to={'/allocate'} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Allocate
                                </NavLink>
                            </li>
                            <li className={permissions.indexOf("ViewAllocationDatabase") < 0 ? "hidden" : "hidden"}>
                                <NavLink className="nav-link alignitemscentre" to={'/allocatedatabase'} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Allocate New
                                </NavLink>
                            </li>
                            <li className={permissions.indexOf("ViewRunSheetUpdates") < 0 ? "hidden" : "nav-item hideMobile"}>
                                <NavLink className="nav-link alignitemscentre" to={'/runsheet'} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Run Sheet
                                </NavLink>
                            </li>
                            <li className={permissions.indexOf("ViewRunSheetUpdates") < 0 ? "hidden" : "nav-item hideMobile"}>
                                <NavLink className="nav-link alignitemscentre" to={'/runsheetdriver'} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Run Sheet Driver({this.state.noRunsheetDriverJobs})
                                </NavLink>
                            </li>
                            <li className={permissions.indexOf("RunReports") < 0 ? "hidden" : "nav-item hideMobile"}>
                                <NavLink className="nav-link alignitemscentre" to={'/reports'} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Reports
                                </NavLink>
                            </li>
                            <li className={permissions.indexOf("CreateEditCustomers") >= 0 || permissions.indexOf("ViewCustomers") >= 0 || permissions.indexOf("CreateQuoteOnlyCustomer") >= 0 ? "nav-item hideMobile" : "hidden"}>
                                <NavLink className="nav-link alignitemscentre" to={'/customersearch'} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Customers
                                </NavLink>
                            </li>
                            <li className={permissions.indexOf("UpdateJobToPaid") < 0 || companyId === 2 ? "hidden" : "nav-item hideMobile"}>
                                <NavLink className="nav-link alignitemscentre" to={'/jobsrequiringpayment'} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Update jobs to Paid
                                </NavLink>
                            </li>
                            <li className={permissions.indexOf("SendInvoices") < 0 ? "hidden" : "nav-item hideMobile"}>
                                <NavLink className="nav-link alignitemscentre" to={'/sendinvoices'} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Send Invoices
                                </NavLink>
                            </li>
                            <li className={permissions.indexOf("ViewInvoices") < 0 ? "hidden" : "nav-item hideMobile"}>
                                <NavLink className="nav-link alignitemscentre" to={'/invoices'} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Invoices
                                </NavLink>
                            </li>
                            <li className={permissions.indexOf("ViewSendInvoiceBatch") < 0 && permissions.indexOf("SendInvoiceBatchEventInvoices") < 0 ? "hidden" : "nav-item hideMobile"}>
                                <NavLink className="nav-link alignitemscentre" to={'/invoicebatch'} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Invoice Batch
                                </NavLink>
                            </li>
                            <li className={permissions.indexOf("ViewSendInvoiceCredits") < 0 ? "hidden" : "nav-item hideMobile"}>
                                <NavLink className="nav-link alignitemscentre" to={'/invoicecredit'} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Invoice Credits({this.state.noCredits})
                                </NavLink>
                            </li>
                            <li className={permissions.indexOf("CreateEditUsers") < 0 ? "hidden" : "nav-item hideMobile"}>
                                <NavLink className="nav-link alignitemscentre" to={'/usersearch'} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Users
                                </NavLink>
                            </li>
                            <li className={permissions.indexOf("CreateEditAdminLists") < 0 ? "hidden" : "nav-item hideMobile"}>
                                <NavLink className="nav-link alignitemscentre" to={'/adminlists'} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Admin Lists
                                </NavLink>
                            </li>
                            <li className={companyId != 2 || this.state.isDriverSystem ? "hidden" : "nav-item hideMobile"}>
                                <NavLink className="nav-link alignitemscentre" to={'/calculator'} target="_black" activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Calculator
                                </NavLink>
                            </li>
                            <li className={this.state.isDriverSystem ? "nav-item" : "hidden"}>
                                <NavLink className="nav-link alignitemscentre" to={logoutPath} activeClassName='active'>
                                    <span className='fas fa-align-justify menu--icon marginRight10'></span> Logout
                                </NavLink>
                            </li>
                        </ul>
                    
                    </div>
                </nav>
            </div>
        );
    }
}